import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {getUserData} from '@/auth/utils'

export default function useProfessionalsList(){

    const toast = useToast()

    const refProfessionalListTable = ref(null)
    const refProfessionalCategoryListTable = ref(null)

    const tableColumns = [
        {key:'image_path', label:'IMAGE'},
        {key:'title'},
        {key:'subtitle', label:'SHORT DESCRIPTION'},
        {key: 'info.name', label: 'LINK'},
        {key:'is_active', label:'status',  sortable:true},
        {key:'actions'}
    ]

    const categoryTableColumns = [
        {key:'label', label:'name'},
        {key:'actions'}
    ]
    const perPage = ref(10)
    const totalProfessionals = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const categoryOptions = ref([])
    

    const dataMeta = computed(() => {
        const localItemsCount = refProfessionalListTable.value ? refProfessionalListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1: 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalProfessionals.value,
        }
    })

    const showMessage = (title,text,icon, variant) =>{
        toast({
            component: ToastificationContent,
            props: {
              title,
              text,
              icon,
              variant
            },
        })
    }

    const refetchData = () =>{
        refProfessionalListTable.value.refresh()
    }

    const getProfessionalImage = (image) =>  process.env.VUE_APP_IMAGE_URL+image

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchProfessionals = (ctx, callback) => {

        store.dispatch('professional/fetchProfessionals', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            store_id: getUserData().store_id,
        })
        .then(response => {
            //console.log(response.data)
            const { professionals, total} = response.data
            callback(professionals)
            totalProfessionals.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                  title: 'Error fetching professionals list',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
            })
        })
    }



    return {
        fetchProfessionals,
        tableColumns,
        categoryTableColumns,
        perPage,
        currentPage,
        totalProfessionals,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refProfessionalListTable,
        refProfessionalCategoryListTable,
        getProfessionalImage,
        categoryOptions,
        showMessage,
        
        
        //Extra Filters
    }

}